import React, {PropTypes} from 'react';
import Error from '../Error';

import {Link} from 'react-router-dom';
import {API} from '../../settings.js';
import {ajaxGet} from '../../helpers/apiData.js';
import {FormattedMessage} from 'react-intl';

import EventItem from './EventItem';
import Empty from './core/Empty';
import PreLoader from '../PreLoader';
import {imagesLoaded} from "../../helpers/imagesLoadCheck";


class EventList extends React.Component {
  static propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    view_info: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.lang = '';
    this.restaurant = '';
    this.state = {
      data: [],
      list_width: 0,
      loading: 'loading',
    };
    this.handleLoading = this.handleLoading.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }


  componentDidMount() {
    this.lang = this.props.match.params.lang;
    this.restaurant = this.props.match.params.restaurant;

    this.updateDimensions();
    ajaxGet(API + this.lang + '/api/' + this.restaurant + '/events/', this);
    window.addEventListener("resize", this.updateDimensions);

    // Sending view info to Restaurant.js to feed the Top and Bottom bars
    this.props.view_info(
      //title
      (<FormattedMessage id="list_event_title">
        {(message) => <span>{message}</span>}
      </FormattedMessage>),
      //view
      'events',
      //back button or not
      true
    );
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  handleLoading() {
    const galleryElement = this.refs.list;
    this.setState({
      loading: imagesLoaded(galleryElement),
    });
  }


  renderResults() {
    // CHECKING FOR ERRORS FROM THE API
    // API GAVE ME AN ERROR :(
    if (this.state.data.status === "error") {
      return (
        <Error restaurant={this.restaurant} lang={this.lang}/>
      );
    }
    let listEvents = '';

    // CHECK IF API RESPONSE HAS ARRIVED
    // CHECK IF THERE ARE ANY RESULTS IN THE RESPONSE
    if (this.state.data.length > 0) {
      // FOUND THE RESULTS, MAPPING THEM HERE AND RENDERING FURTHER BELOW
      listEvents = this.state.data.map((item) => {
        return (
          <div className="list-item" key={item.id}>
            <Link to={'/' + this.lang + '/' + this.restaurant + `/events/` + item.slug}>
              <EventItem name={item.title} slug={item.slug}
                         image={item.display_image} description={item.description}
                         start={item.start} list="true" pk={item.id}
                         end={item.end} loading={this.handleLoading} template={"event"}
              />
            </Link>
          </div>
        );
      });
      return (
        <div className={'item-list ' + this.state.loading} style={{width: this.state.list_width}} ref="list">
          <button className="btn body-back-btn" onClick={this.props.history.goBack}/>
          {/* Once images are loaded, call the function that maps the products and renders them */}
          <div className="list-wrapper">{listEvents}</div>
        </div>
      );
    }
    else { // NO RESULTS WERE FOUND, RENDER A MSG
      return (
        <div className="item-list loaded">
          <Empty/>
        </div>
      );
    }

  }

  updateDimensions() {
    if (window.innerWidth > 1024) {
      this.setState({list_width: window.innerWidth - 120});
    }
    else {
      this.setState({list_width: window.innerWidth});
    }
  }

  render() {
    // FOUND THE RESULTS RENDERING THE MAPPED ITEMS HERE
    return (
      <div className="content-wrapper">
        <PreLoader/>
        {this.renderResults()}
      </div>

    );
  }
}

export default EventList;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/EventList.js
 **/